import React from 'react';
import { Modal, CheckBox, DropdownSelector, TimeSelector } from 'hyperdb-utils';

const ReservationExtraInfos = (props) => {
  const handleChange = (attributeName, field) => {
    let { name, value } = field;
    if (["arrival_time", "departure_time"].includes(attributeName)) {
      if (value === "Invalid date") value = null;
    }
    props.onChange({ ...props.editedExtraInfo, [attributeName]: value });
  };
  const handleClickCheckbox = (attributeName, field) => {
    const checked = !props.editedExtraInfo[attributeName];
    props.onChange({ ...props.editedExtraInfo, [attributeName]: checked });
  };
  const displayBoolean = (bool) => {
    return bool ? <i className="fas fa-check text-success" /> : <i className="fas fa-remove text-danger" />;
  };
  const transportsOptions = () => {
    return ['plane', 'train', 'bus', 'taxi', 'car', 'motorbike', 'bicycle', 'foot'].map(t => {
      return { name: t, value: t };
    });
  };

  return (
    <div>
      <table className="table table-bordered table-striped details">
        <thead>
          <tr className="info">
            <th colSpan="2">
              Extra information
              &nbsp; <button onClick={ props.toggleModal.bind(null, true) } className="btn btn-primary btn-sm" title="Edit"><i className="fas fa-edit"/></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Confirmation printed</td>
            <td>{ displayBoolean(props.reservation.confirmation_printed) }</td>
          </tr>
          <tr>
            <td>Arrival transport</td>
            <td>{ props.reservation.arrival_transport }</td>
          </tr>
          <tr>
            <td>Arrival time</td>
            <td>{ props.reservation.arrival_time }</td>
          </tr>
          <tr>
            <td>Departure transport</td>
            <td>{ props.reservation.departure_transport }</td>
          </tr>
          <tr>
            <td>Departure time</td>
            <td>{ props.reservation.departure_time }</td>
          </tr>
          <tr>
            <td>Leave the keys</td>
            <td>{ displayBoolean(props.reservation.leave_keys) }</td>
          </tr>
          <tr>
            <td>Parking reserved</td>
            <td>{ displayBoolean(props.reservation.parking_reserved) }</td>
          </tr>
        </tbody>
      </table>
      {
        props.showModal
          ? <Modal show={true} onClose={props.toggleModal.bind(null, false)} onAccept={props.onSave}>
              <CheckBox
                label="Confirmation printed"
                name="confirmation_printed"
                checked={ props.editedExtraInfo.confirmation_printed }
                onChange={ handleClickCheckbox.bind(null, 'confirmation_printed') }
              />
              <DropdownSelector
                label="Arrival transport"
                name="arrival_transport"
                value={ props.editedExtraInfo.arrival_transport || '' }
                options={ transportsOptions() }
                onChange={ handleChange.bind(null, 'arrival_transport') }
              />
              <fieldset>
                <legend>Arrival time</legend>
                <TimeSelector
                  label="Arrival time"
                  name="arrival_time"
                  value={ props.editedExtraInfo.arrival_time }
                  onChange={ handleChange.bind(null, 'arrival_time') }
                />
              </fieldset>
              <DropdownSelector
                label="Departure transport"
                name="departure_transport"
                value={ props.editedExtraInfo.departure_transport || '' }
                options={ transportsOptions() }
                onChange={ handleChange.bind(null, 'departure_transport') }
              />
              <fieldset>
                <legend>Departure time</legend>
                <TimeSelector
                  label="Departure time"
                  name="departure_time"
                  value={ props.editedExtraInfo.departure_time }
                  onChange={ handleChange.bind(null, 'departure_time') }
                />
              </fieldset>
              <CheckBox
                label="Must leave keys"
                name="leave_keys"
                checked={ props.editedExtraInfo.leave_keys }
                onChange={ handleClickCheckbox.bind(null, 'leave_keys') }
              />
              <CheckBox
                label="Parking reserved"
                name="parking_reserved"
                checked={ props.editedExtraInfo.parking_reserved }
                onChange={ handleClickCheckbox.bind(null, 'parking_reserved') }
              />
            </Modal>
          : null
      }
    </div>
  );
};

export default ReservationExtraInfos;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ReservationExtraInfos.jsx